import React from 'react'
import { Field } from 'formik'
import { FormControl, TextField } from '@mui/material'
import { ErrorMessage } from 'formik'
import  TextError  from './TextError'

function Input(props) {
  const { label, name, readOnly = false, ...rest } = props

  return (
    <Field name={name}>
      {({ field, form, meta }) => {
       
        return(
        <FormControl fullWidth error={meta.error && meta.touched}>
          <TextField
            fullWidth
            {...field}
            {...rest}
            label={label}
            autoComplete='off'
            InputProps={{
              readOnly: readOnly, 
            }}
            // error={form.touched[name] && Boolean(form.errors[name])}
            // helperText={form.touched[name] && form.errors[name]}
          />
          <ErrorMessage component={TextError} name={name} />
        </FormControl>
      )}}
    </Field>
  )
}

export default Input
